import React, { useEffect } from 'react'

export default function AttachmentViewer({ url, type, onClose }) {
    useEffect(() => {
        console.log("AttachmentViewer mounted")
        //console.log("URL:", url)
        //console.log("Type:", type)
    }, [url, type])

    const isVideo = type === 'video'

    // Convert public URL to bucket path
    const getBucketPath = url => {
        const pathMatch = url.match(/o\/(.+)\?/)
        if (!pathMatch) return null
        return decodeURIComponent(pathMatch[1])
    }
 
    // Handle download
    const handleDownload = url => {
        const path = getBucketPath(url)
        if (!path) return console.error("Invalid URL")
        const downloadEndpoint = `https://us-central1-zindua-ke.cloudfunctions.net/downloadFile/download?path=${encodeURIComponent(path)}`
        window.open(downloadEndpoint, "_blank")
    }

    return (
        <div className="attachmentViewerOverlay">
            <div className="attachmentViewerContent">
                <div className="attachmentViewerHeader">
                    <button onClick={onClose} className="attachmentCloseBtn">Close</button>
                </div>

                <div className="attachmentViewerBody">
                    {isVideo ? (
                        <video src={url} controls autoPlay className="attachmentViewerMedia" />
                    ) : (
                        <img src={url} alt="attachment" className="attachmentViewerMedia" />
                    )}
                </div>

                <button
                    className="attachmentDownloadLink"
                    onClick={() => handleDownload(url)}
                >
                    Download
                </button>
            </div>
        </div>
    )
}